import { Component, OnInit, OnDestroy, Compiler, ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';

import { CookieService } from 'ngx-cookie-service';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;


@Component({
	selector: 'app-top-trending-survey',
	templateUrl: './top-trending-survey.component.html',
	styleUrls: ['./top-trending-survey.component.css']
})
export class TopTrendingSurveyComponent implements OnInit {

	surveyList: any =[];
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	surveyStatus: any = "";
	config = {
		width: "40px", //width of slides defaults to 800px
		height: "40px", //height of slides defaults to 300px
		autoPlay: true, //autoplay required or not defaults to false
		delay: 3000, // delay for autoplay
	}
	
	
	activePageNo: number = 0;
    user_id="";
	@ViewChild('videoPlayer') videoplayer: ElementRef;

	constructor(
		private commonService: CommonService,
		private authService: AuthService,
		private router: Router, 
		private pagerService: PagerService, 
		
		private activatedRoute: ActivatedRoute

		) { }

	ngOnInit() {
		
		this.commonService.process();
		$(".navbar-brand").text("Top Trending Survey");

		this.activatedRoute.params.subscribe((params: any) => {
			this.user_id = params.user_id;
			// this.initialiseLikeActivity();
		});
		
		this.pageNo = 1;
		this.limit = 10;
		this.surveyStatus = 0;
		this.getTopFavoriteSurveys(this.pageNo, this.limit, "", "", this.surveyStatus, "", "");

	}

	getTopFavoriteSurveys = function (pageNo, limit, searchString, searchCategory, surveyStatus, range, target) {
		this.commonService.process();
		this.authService.getTopFavoriteSurveys(pageNo, limit, searchString, searchCategory, surveyStatus, range, target).subscribe(data => {
			if (data.success) {
				this.isSurveyAvailable = true;
				data.survey.forEach((element, index) => {
					this.surveyList.push(element);
				});
				this.total = data.total;
				this.setPage(pageNo, true);
			}else {
				this.surveyList = [];
				this.total = 0;
				this.isSurveyAvailable = false;
			}
			this.commonService.hideProcess();
		});
	}



	setPage(page: number, param) {

		$('.pages.active a').each(function () {
			if (parseInt($(this).text()) != page)
				$(this).parent('li').removeClass('active');
		});
		if ($('#first, #prev').hasClass('disabled') && page != this.pager.totalPages && page != 1)
			$('#first, #prev').removeClass('disabled');
		if ($('#next, #last').hasClass('disabled') && page != this.pager.totalPages)
			$('#next, #last').removeClass('disabled');

		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		this.pager = this.pagerService.getPager(this.total, page);
		// get current page of items
		this.pagedItems = this.surveyList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getTopFavoriteSurveys(page, this.limit, "", "", this.surveyStatus, "", "");
		}
	}

	//initialiseLikeActivity = function () {
		// this.limit = 10;
		// this.pageNo = 1;
		// this.getLikeActivityRepoort(this.pageNo, this.limit);
	//}

	// Get survey list
	// getLikeActivityRepoort = function (pageNo, limit) {

	// 	this.commonService.process();
		
	// 	this.authService.FavouriteGroupSurveyList(pageNo,limit).subscribe(data => {

	// 		if (data.success) {
	// 			this.isSurveyAvailable = false;
	// 			this.surveyList = data.survey;
	// 			this.total = data.total;
	// 			this.setPage(pageNo, true);
	// 			this.pageNo = pageNo;

	// 		}else{

	// 			this.surveyList = [];
	// 			this.isSurveyAvailable = true;
	// 		}
	// 		this.commonService.hideProcess();
	// 	});
	// }

	// Pagination
	

	// Search survey
	// searchSurvey = function () {
	// 	this.searchStr = $("#search").val();
	// 	this.surveyCategory = $("#surveyCategory").val();
	// 	this.surveyStatus = $("#surveyStatus").val();
	// 	this.getLikeActivityRepoort(1, this.limit);
	// }


	
	toggleVideo(event: any) {
		this.videoplayer.nativeElement.play();
	}

	imageSlider(data){
		var imageArr = [];

		data.forEach((element,index) => {
			imageArr.push({
				image: element,
				title: '' 
			});
		});

		return imageArr
	}

	calculateExpiry = function (expiryTime) {
		this.surveyExpiryDate = new Date(expiryTime);
		this.currentDate = new Date();
		this.currentDate = new Date(this.currentDate.toISOString());
		var seconds = Math.floor((this.surveyExpiryDate - this.currentDate) / 1000);
	
		if(Math.round(seconds/(60*60*24*365.25)) >= 2) return Math.round(seconds/(60*60*24*365.25)) + " Years";
		else if(Math.round(seconds/(60*60*24*30.4)) >= 2) return Math.round(seconds/(60*60*24)) + " Days";
		else if(Math.round(seconds/(60*60*24)) >= 2) return Math.round(seconds/(60*60*24)) + " Days";
		else if(Math.round(seconds/(60*60*24)) >= 1 && Math.round(seconds/(60*60))>24) return "1 day ";
		else if(Math.round(seconds/(60*60)) >= 2) return Math.round(seconds/(60*60)) + " Hours";
		else if(Math.round(seconds/(60*60)) >= 1) return "1 Hour";
		else if(Math.round(seconds/60) >= 2) return Math.round(seconds/60) + " Minutes";
		else if(Math.round(seconds/60) >= 1) return "1 Minute";
		else if(seconds >= 2)return seconds + " Seconds";
		else if(seconds >= 1)return seconds + "1 Second";
		else return 'Few Seconds';
	};


}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/top-trending-survey/top-trending-survey.component.ts